import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function BucketIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M21.7778 31H10.2222C7.04444 31 4.44444 28.75 4.44444 26V9.75C4.44444 9 5.02222 8.5 5.88889 8.5H26.1111C26.9778 8.5 27.5556 9 27.5556 9.75V26C27.5556 28.75 24.9556 31 21.7778 31ZM13.1111 26C13.9778 26 14.5556 25.5 14.5556 24.75V14.75C14.5556 14 13.9778 13.5 13.1111 13.5C12.2444 13.5 11.6667 14 11.6667 14.75V24.75C11.6667 25.5 12.2444 26 13.1111 26ZM20.3333 24.75V14.75C20.3333 14 19.7556 13.5 18.8889 13.5C18.0222 13.5 17.4444 14 17.4444 14.75V24.75C17.4444 25.5 18.0222 26 18.8889 26C19.7556 26 20.3333 25.5 20.3333 24.75ZM27.5556 3.5H21.7778C21.7778 2.125 20.4778 1 18.8889 1H13.1111C11.5222 1 10.2222 2.125 10.2222 3.5H4.44444C3.57778 3.5 3 4 3 4.75C3 5.5 3.57778 6 4.44444 6H27.5556C28.4222 6 29 5.5 29 4.75C29 4 28.4222 3.5 27.5556 3.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
